import React from 'react'

import NavigationMenuSection from "../../menu-items/section/section"
import {SESSION_PINS_CHANGED} from "../../../../core/gd/bus/bus-event-type"
import Pin from "../../../../core/model2/pin/pin"

// @ts-ignore
import SessionLoader from "../../../../core/gd/data/session-loader";
import NavigationMenuItemTask from "../../menu-items/task/menu-item-task"
import NavigationMenuItemDocument from "../../menu-items/document/menu-item"
import NavigationMenuItemUser from "../../menu-items/user/menu-item-user"
import MainMenu_SectionReorderableWithMore from "../../components/menu-controller/menu-section-reordable-with-more";
import {SpaceProto} from "../../../../core/model2/space/space-proto";
import {EntityType} from "../../../../core/gd/const/item";
import NavigationMenuItemProjectWithChildren from "../../menu-items/project/menu-item-project-with-children";
import NavigationMenu_ProjectsLocalSettings from "../../local-settings";
import ErrorBoundary from "../../../../core/error-boundary";


type State = {
    loaded      : boolean,
    reRender?   : boolean
}

type Props = {
    // navigationSection   : NavigationSection
    space           : SpaceProto
}

// const debug = "MainMenu_Pins"
const debug = false

export default class MainMenu_Pins extends React.Component<Props, State> {

    private localSettings       : NavigationMenu_ProjectsLocalSettings

    constructor(props:Props) {
        super(props)

        this.state = {
            loaded: false,
        }

        this.localSettings = new NavigationMenu_ProjectsLocalSettings()
    }

    componentDidMount() {
        gd.bus.subscribe(SESSION_PINS_CHANGED, this, this.sessionDataChanged)
        this.loadMissingData();
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    sessionDataChanged = () => {
        this.setState({
            reRender: true
        });
    };

    loadMissingData() {
        const taskTypes: ID[] = [];
        gd.session.pins.models.map((i:any)=>{if (i.task) taskTypes.push(i.task.taskTypeId)});
        const getMissingData = ()=>gd.session.findMissing({taskTypes: _.uniq(taskTypes)});

        //load missing task types if needed
        if (_.keys(getMissingData()).length > 0) {
            let sessionLoader = new SessionLoader();
            //check and load later because main app (my work) also may load these taskTypes
            setTimeout(()=>{sessionLoader.process(getMissingData())}, 1000);
            sessionLoader.done(()=>{
                this.setState({loaded: true});
            })

        } else {
            this.setState({loaded: true});
        }
    }

    onReorderEnd = (items:any) => {
        gd.user.settings.menu.pinsItems.sortPositions = items.map((item:any)=>item.id);
        gd.user.settings.menu.save();
    };

    render() {

        let pinnedItems : Pin[] = gd.session.pins.spacePins(this.props.space)

        debug && console.log(debug, "render() pinnedItems=", pinnedItems)

        if (!pinnedItems || pinnedItems.length < 1) return null

        // resort according to sort positions
        pinnedItems = _.sortBy(pinnedItems, (pin)=>{
            let sortPosition = _.indexOf(gd.user.settings.menu.pinsItems.sortPositions, pin.id);
            if (sortPosition===-1) sortPosition = 999;
            return sortPosition;
        });

        const components = _(pinnedItems)
            .map((pin : Pin)=> {

                switch (pin.type) {


                    case EntityType.PROJECT:

                        const sessionProject = gd.session.projects.get(pin.project!.id)

                        // this hides archived pins
                        if (!sessionProject || sessionProject.isArchived) {
                            return
                        }

                        return {
                            item        : pin,
                            component   : <NavigationMenuItemProjectWithChildren projectId                     = {pin.project!.id}
                                                                                 colorized                     = {true}
                                                                                 localSettings                 = {this.localSettings}
                                                                                 expandedProjectsSettingName   = "expandedPinnedProjects"/>
                        }

                    case EntityType.TASK_TYPE:
                        return {
                            item        : pin,
                            component   : <NavigationMenuItemTask task={pin.task!} />
                        }

                    case EntityType.USER:
                        return {
                            item: pin,
                            component: <NavigationMenuItemUser companyUser={gd.session.companyUsers.get(pin.user!.companyId + "-" + pin.user!.userId)} />
                        }

                    case EntityType.DOCUMENT:
                        return {
                            item: pin,
                            component: <NavigationMenuItemDocument document={pin.document!} />
                        }

                    default:
                        console.error("MainMenu_Pins: Unknown type " + pin.type)
                }
            })
            .compact()
            .value()

        debug && console.log(debug, "    components=", components)

        return (
            <NavigationMenuSection name="Pinned Items" collapsible={true} systemName={"pins-"+this.props.space.id} counter={pinnedItems.length}>
                <ErrorBoundary>
                    <MainMenu_SectionReorderableWithMore countVisibleItems   = {5}
                                                         settingsKey         = "home-pinned-items"
                                                         moreTitle           = "All Items"
                                                         showAdd             = {false}
                                                         components          = {components}
                                                         onReorderEnd        = {this.onReorderEnd}/>
                </ErrorBoundary>
            </NavigationMenuSection>
        );
    }
}
